// extracted by mini-css-extract-plugin
module.exports = {"latest-list":"styles-m__latest-list__2C_er","li-list":"styles-m__li-list__2jAaC","ul-grid":"styles-m__ul-grid__3wkt-","footer-title":"styles-m__footer-title__jFcuq"};